
import { Options, Vue } from 'vue-class-component';

@Options({
  data() {
    return {
      list: [],
    }
  },
  mounted () {
    const total = Math.floor(Math.random() * 5 + 2);
    for (let i = 0; i < total; i++) {
      this.list.push(Math.random() > 0.8 ? 'cube' : 'triangle');
    }
  },
  methods: {
    
  },
})
export default class Home extends Vue {}
